import { useState, useCallback, useEffect } from "react";
import debounce from "lodash/debounce";
import User from "../passapp-sdk/user";
import { useStore } from "./useStore";

const userSdk = new User();

export const useEmployeeSearch = (query: string) => {
  const { authStore } = useStore();
  const [employees, setEmployees] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  const fetchEmployees = useCallback(
    debounce(async (searchQuery: string, token: string) => {
      if (!searchQuery || searchQuery.trim().length < 2) {
        setEmployees([]);
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const response = await userSdk.findEmployees(token, searchQuery);
        setEmployees(response.data || []);
      } catch (err) {
        console.error("Error searching employees:", err);
        setError(err);
        setEmployees([]);
      } finally {
        setIsLoading(false);
      }
    }, 400),
    []
  );

  useEffect(() => {
    if (query.trim().length >= 2) {
      setIsLoading(true);
      fetchEmployees(query, authStore.token);
    } else {
      setEmployees([]);
      setIsLoading(false);
      fetchEmployees.cancel();
    }
  }, [query, authStore.token, fetchEmployees]);

  return { employees, isLoading, error };
};
